export default {
	cargadoComponenteApp: false,
	drawer: null,
	cartDrawer: false,
	loading: true,
	loadingComunes: true,
	titlePage: '',
	dialogLogin: false,
	dialogFinalizar: false,
	dialogReiniciarPedido: false,
	dialogIdiomas: false,
	lang: {
		key: '',
		value: ''
	},
	dialogCambio: false,
	windowOrientation: 0,
	isTablet: false,
	isMobile: false,
	isSafari: true,
	internetConnection: true,
	negocioObj: null,
	modoGeneral: 'funeat', //funeat o propio 
	router: null, //se copia el objeto router para usarlo unav ez montado
	cookiesNav: false,
	cookiesAccept: '',
	modoDesarrollo: 'desarrollo' // desarrollo o produccion
}
